// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getDatabase, update, ref, onValue } from "firebase/database";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// **************************************  UNREAL ENGINE (p2eApp) *********************************

const firebaseConfigUE = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY_UE,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN_UE,
  databaseURL: process.env.NEXT_PUBLIC_DATABASE_URL_UE,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID_UE,
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET_UE,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGE_SENDER_ID_UE,
  appId: process.env.NEXT_PUBLIC_APP_ID_UE,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID_UE,
};

// Initialize the "p2eApp" instance safely
let p2eApp;
try {
  // Check if already initialized to avoid "app already exists" error
  const { getApp } = require("firebase/app");
  p2eApp = getApp("p2eApp");
} catch (e) {
  // Only initialize if we have an API key (avoids build errors)
  if (firebaseConfigUE.apiKey) {
    p2eApp = initializeApp(firebaseConfigUE, "p2eApp");
  }
}

// Export specialized instances (nullable if config missing)
export const p2eAuth = p2eApp ? getAuth(p2eApp) : null;
export const p2eDb = p2eApp ? getFirestore(p2eApp) : null;
export const p2eStorage = p2eApp ? getStorage(p2eApp) : null;
export const p2eDatabase = p2eApp ? getDatabase(p2eApp) : null;

// ***********************************************************************

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  databaseURL: process.env.NEXT_PUBLIC_DATABASE_URL,
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGE_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Analytics sets the _ga cookies, so _app.js starts it only as the visitor's choice and
// country allow (see lib/consent.ts). Nothing here runs at import time.
let analytics = null;

export const startAnalytics = async () => {
  if (!(await isSupported())) return;
  analytics = getAnalytics(app);
  setAnalyticsCollectionEnabled(analytics, true);
};

// For a visitor who accepted and later rejects: stop sending hits and drop the
// cookies already set, on this host and every parent domain GA may have used.
export const stopAnalytics = () => {
  if (analytics) setAnalyticsCollectionEnabled(analytics, false);
  const parts = window.location.hostname.split(".");
  const domains = parts.map((_, i) => parts.slice(i).join("."));
  document.cookie.split(";").map(c => c.split("=")[0].trim()).filter(n => n.startsWith("_ga")).forEach(name => {
    document.cookie = `${name}=; Max-Age=0; path=/`;
    domains.forEach(d => { document.cookie = `${name}=; Max-Age=0; path=/; domain=${d}`; });
  });
};

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

export const db = getFirestore(app);

// Export function to initialize firebase
export const initFirebase = () => {
  return app;
};

export const auth = getAuth(app);

export function updateData(updates) {
  update(ref(database), updates);
}

export async function getData(uid) {
  var job = "";
  var bio = "";
  onValue(ref(database, '/user_profile/' + uid), (snapshot) => {
    job = snapshot.val().job_position;
    bio = snapshot.val().bio;
    // ...
  }, {
    onlyOnce: true
  });
  return { job: job, bio: bio }
}

